import { createFileRoute } from '@tanstack/react-router'
import { PropertyCreatePage } from '../../../components/PropertyCreatePage'
import { PermissionDeniedState } from '../../../components/PermissionDeniedState'
import { useCan } from '../../../contexts/PermissionsContext'

export const Route = createFileRoute('/$org/properties/create')({
  component: CreateProperty,
})

function CreateProperty() {
  // The section's `read` guard let this caller in; creating needs `write`, so
  // a deep link to /create must not hand them a form that can only 403.
  const canWrite = useCan('configuration.write')
  if (!canWrite) return <PermissionDeniedState permission="configuration.write" />
  return <PropertyCreatePage />
}
